// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12o9M","input":"styles_input__2ne_U"};